import { createAsyncThunk } from "@reduxjs/toolkit";

import { updateDeploymentNextRequest } from "Api/organizations/projects/environments/deployments/updateDeploymentNext.request";
import { isUpdateLoadingSelector } from "../deployment.selectors";

import type { UpdateDeploymentProps } from "../types";
import type { Deployment } from "Api/organizations/projects/environments/deployments/types";
import type { AsyncThunkOptionType } from "Reducers/types";

export const updateDeployment = createAsyncThunk<
  Deployment,
  UpdateDeploymentProps,
  AsyncThunkOptionType
>(
  "app/environmentDeployment/update",
  async ({ projectId, environmentId, data }, { rejectWithValue }) => {
    try {
      const result = await updateDeploymentNextRequest({
        projectId,
        environmentId: encodeURIComponent(environmentId),
        deploymentData: data
      });

      const updateDeployment = result._embedded.entity;

      return updateDeployment;
    } catch (error) {
      return rejectWithValue(error as { code: number; message: string });
    }
  },
  {
    condition: (_, { getState }) => !isUpdateLoadingSelector(getState())
  }
);
